/**
 * Map natural (intrinsic) pixel coordinates to positions inside an <img> box
 * when the image is displayed with object-fit: contain (letterboxed).
 */
export function naturalToDisplayedImageCoords(imgEl, xNatural, yNatural) {
    if (!imgEl || !imgEl.naturalWidth || !imgEl.naturalHeight) {
        return { x: 0, y: 0 };
    }
    const nw = imgEl.naturalWidth;
    const nh = imgEl.naturalHeight;
    const rect = imgEl.getBoundingClientRect();
    const rw = rect.width;
    const rh = rect.height;
    const scale = Math.min(rw / nw, rh / nh);
    const offsetX = (rw - nw * scale) / 2;
    const offsetY = (rh - nh * scale) / 2;
    return {
        x: offsetX + xNatural * scale,
        y: offsetY + yNatural * scale,
    };
}

/**
 * Inverse: click position relative to the image element → natural pixels (for object-fit: contain).
 */
export function displayedToNaturalImageCoords(imgEl, xDisplay, yDisplay) {
    if (!imgEl || !imgEl.naturalWidth || !imgEl.naturalHeight) {
        return { x: 0, y: 0 };
    }
    const nw = imgEl.naturalWidth;
    const nh = imgEl.naturalHeight;
    const rect = imgEl.getBoundingClientRect();
    const rw = rect.width;
    const rh = rect.height;
    const scale = Math.min(rw / nw, rh / nh);
    const offsetX = (rw - nw * scale) / 2;
    const offsetY = (rh - nh * scale) / 2;
    return {
        x: Math.round((xDisplay - offsetX) / scale),
        y: Math.round((yDisplay - offsetY) / scale),
    };
}
